import { createClient, SanityClient } from "next-sanity";
import { dataset, projectId, readToken, apiVersion } from "../api";

export const getClient = (args?: { preview?: boolean }): SanityClient => {
  if (args?.preview) {
    return createClient({
      projectId,
      dataset,
      apiVersion,
      token: readToken,
      useCdn: false,
      ignoreBrowserTokenWarning: true,
      perspective: "previewDrafts",
      withCredentials: true,
    });
  }

  return createClient({
    projectId,
    dataset,
    apiVersion,
    useCdn: false,
    perspective: "published",
  });
};
